module.exports = __webpack_public_path__ + "assets/icons/ic_picture_as_pdf-59f0.svg";